import { Helmet } from 'react-helmet-async';
import { LOCATION_KEYWORDS, SITE_NAME, absoluteUrl, DEFAULT_OG_IMAGE } from '@/lib/seo';

type SeoHeadProps = {
  title: string;
  description: string;
  keywords?: string[];
  path: string;
  image?: string;
};

export function SeoHead({ title, description, keywords = [], path, image }: SeoHeadProps) {
  const mergedKeywords = [...new Set([...keywords, ...LOCATION_KEYWORDS])].join(', ');
  const canonical = absoluteUrl(path);
  const ogImage = image || DEFAULT_OG_IMAGE;

  const suffix = "Construction Company in Jaffna | AST Construction";
  let displayTitle = title;
  if (title !== suffix && !title.includes(suffix)) {
    if (title.includes("AST Construction")) {
      displayTitle = title.replace(/ \| AST Construction$/, ` | ${suffix}`);
    } else {
      displayTitle = `${title} | ${suffix}`;
    }
  }

  return (
    <Helmet>
      <title>{displayTitle}</title>
      <meta name="title" content={displayTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={mergedKeywords} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={displayTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={displayTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
